import type { PosVariant, PosVariantDetailItem } from '../types';

export function mapDetailToPosVariant(detail: PosVariantDetailItem): PosVariant {
  const weightStr = detail.variant.attrs.weight_g?.value;
  const weight = weightStr !== undefined ? Number(weightStr) : NaN;
  return {
    variant_id: detail.variant.variant_id,
    variant_name: detail.product.name,
    variant_code: detail.variant.variant_code,
    specification_code: detail.stock_serial?.serial ?? undefined,
    tracking_mode: detail.product.tracking_mode,
    pricing_method: detail.variant.pricing_model ?? undefined,
    price: Math.ceil(detail.price.price),
    weight: Number.isFinite(weight) && weight > 0 ? weight : undefined,
    labor_fee: detail.variant.fees?.making_fee,
    vat: detail.product.vat,
    warehouse_staff_ids: detail.warehouse_staff_ids?.map((s) => s.warehouse_staff_id),
    instrument_code: detail.price.instrument_code,
    applied_bid: detail.price.applied_bid,
    applied_ask: detail.price.applied_ask,
    applied_ts: detail.price.applied_ts,
    override_applied: detail.price.override_applied,
  };
}
